module.exports = __webpack_public_path__ + "img/42Clinton.da09cea9.png";